import { Orientation } from '@core/domain/state/core.state';
import { SkeletonStyles } from '@features/cms-render/ui/render-pieces/md-skeleton/md-skeleton.models';

export class PieceVideoUtils {
    public static getSkeleton(
        general: { portraitPosterImage: any; landscapePosterImage: any },
        orientation: Orientation
    ): SkeletonStyles {
        const aspectRatio = orientation === 'portrait'
            ? `${general.portraitPosterImage.width} / ${general.portraitPosterImage.height}`
            : `${general.landscapePosterImage.width} / ${general.landscapePosterImage.height}`;

        return {
            aspectRatio,
        };
    }
}
